var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIncrease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6669 7C19.8508 7.00018 19.9997 7.14917 19.9999 7.33301V10.8623C19.9997 11.0461 19.8507 11.1951 19.6669 11.1953C19.5785 11.1953 19.4931 11.1602 19.4306 11.0977L18.1376 9.80469L13.1376 14.8047C12.8973 15.0449 12.5192 15.0637 12.2577 14.8604L12.1952 14.8047L9.99992 12.6104L5.13762 17.4717C4.8973 17.7117 4.51914 17.7305 4.25774 17.5273L4.19524 17.4717C3.95501 17.2315 3.93649 16.8533 4.13957 16.5918L4.19524 16.5283L9.52824 11.1953C9.76847 10.9551 10.1466 10.9366 10.4081 11.1396L10.4716 11.1953L12.6669 13.3896L17.1943 8.86133L15.9023 7.56934C15.7721 7.43917 15.7721 7.22783 15.9023 7.09766C15.9647 7.03523 16.0493 7.0001 16.1376 7H19.6669Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIncrease);
export default __webpack_public_path__ + "static/media/ArrowIncrease.ef2d5fee5dbda0bd91ac3a66499a276b.svg";
export { ForwardRef as ReactComponent };